import { cx } from '@linaria/core';

// TODO: еще подумать над кнопками, какие-то они не атомы
// eslint-disable-next-line boundaries/element-types
import { Skeleton } from '~shared/ui/atoms/Skeleton';

import { ButtonBase } from '..';
import type { SizeButtonBaseProps } from '../types';
import {
	Icon,
	MainContent,
	MainContentCaptions,
	skeletonStyle,
	styledButton,
} from './styles';

export const SizeButtonBase = ({
	size = 'S',
	className,
	children,
	leftIcon,
	rightIcon,
	width,
	disabledIconStyles = false,
	skeleton = false,
	...props
}: SizeButtonBaseProps) => {
	const textSize = size === 'L' ? 'M' : size === 'Badge' ? 'L' : 'S';
	const ContentElement = size === 'Badge' ? MainContentCaptions : MainContent;
	return (
		<ButtonBase
			style={{ width: width ? `${width}px` : undefined }}
			className={cx(
				styledButton,
				`size${size}`,
				skeleton && 'skeleton-on',
				className
			)}
			{...props}
		>
			{skeleton && <Skeleton className={cx(skeletonStyle, 'skeleton')} />}
			{leftIcon && (
				<Icon
					as="span"
					size={textSize}
					className={cx(
						'icon-inside-button',
						'left',
						disabledIconStyles && 'disabledIconStyles'
					)}
				>
					{leftIcon}
				</Icon>
			)}
			{children && <ContentElement size={textSize}>{children}</ContentElement>}
			{rightIcon && (
				<Icon
					as="span"
					size={textSize}
					className={cx(
						'icon-inside-button',
						'right',
						disabledIconStyles && 'disabledIconStyles'
					)}
				>
					{rightIcon}
				</Icon>
			)}
		</ButtonBase>
	);
};
